"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMemberCookie = exports.setMemberCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var memberAuthCookie = "_ms-mid";
exports.setMemberCookie = function (token, expires) {
  js_cookie_1.default.set(memberAuthCookie, token, {
    expires: expires && Number(expires) || 3,
    sameSite: "strict"
  });
};
exports.getMemberCookie = function () {
  return js_cookie_1.default.get(memberAuthCookie);
};